import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faQuestion, faNewspaper, faLanguage, faWrench, faCloudSun, faUsersCog, faLock, faHouseUser, faCalendarCheck, faWalking, faBox } from '@fortawesome/free-solid-svg-icons'
import { Toggle } from '../Library'
import { feature } from '../Network/Administration'
import "./FeatureItem.css"
import miniIcon from '../asset/image/mini-logo.png'

export default function FeatureItem({ title, detail, identifier, isEnable, onToggle }){

    const iconIdentifier = () =>{
        if(identifier === feature.NEWS){
            return faNewspaper
        }else if(identifier === feature.CALENDAR ){
            return faCalendarAlt
        }else if(identifier === feature.LANGUAGE){
            return faLanguage
        }else if(identifier === feature.SERVICE){
            return faWrench
        }else if(identifier === feature.WIDGET){
            return faCloudSun
        }else if(identifier === feature.USER){
            return faUsersCog
        }else if(identifier === feature.PERMISSION){
            return faLock
        }else if(identifier === feature.TENANT){
            return faHouseUser   
        }else if(identifier === feature.BOOKING){
            return faCalendarCheck
        }else if(identifier === feature.DELIVERY){
            return faBox
        }else if(identifier === feature.VISITOR){
            return faWalking
        }else{
            return faQuestion
        }
        
    }

    return(
        <div className="feature-item">
            <div className="icon-box">
                { identifier === feature.LINK ?
                <img src={miniIcon} style={{ width: "100%", height: "100%", objectFit: 'contain', padding: 5 }}/> :
                <FontAwesomeIcon icon={iconIdentifier()}/>
                }
            </div>
 
            <div style={{ flex: 1 }}>
                <div className="title">{title}</div>
                <div className="detail">{detail}</div>
            </div>
            {
            <div>
                <Toggle isTurnon={isEnable} onChange={onToggle}/>
            </div>
            }
        </div>
    )
}